import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-test-de-vida-categoria',
  templateUrl: './categoria-test-de-vida.component.html',
  styleUrls: ['./categoria-test-de-vida.component.css']
})
export class CategoriaTestVidaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
